import { event } from 'devextreme/events';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
    FormControl,
    FormGroup,
    Validators,
    FormBuilder,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { OrderService } from 'src/app/services/order/order.service';
import { ActivatedRoute } from '@angular/router';
import { SettingService } from 'src/app/services/setting/setting.service';

@Component({
  selector: 'app-phlebo-feedback',
  templateUrl: './phlebo-feedback.component.html',
  styleUrls: ['./phlebo-feedback.component.scss']
})
export class PhleboFeedbackComponent implements OnInit {
  @Input() props: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();


  public ngrating:any;
  public ngremark:any;
  public ratingData:any = [];
  public isBtnLoaded = false;
  checkExisit=true;
  public id: any;
  public starRating:any ;
  isDeviceService = true;
  finalLogoUrl: string = '';
  constructor( private ngbModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private orderService: OrderService,
    private settingService: SettingService,
    private toastr: ToastrService,
    private actRoute: ActivatedRoute

    ) {
      this.actRoute.paramMap.subscribe(params => {
        this.id = params.get('id');
        this.checkExisit =false;
      });
    }

  ngOnInit(): void {
    this.starRating = 0;
    this.orderService.getCompanyDetails(this.id).subscribe({
    next: (res) => {
      console.log('Company Details:', res);
        this.isDeviceService = res?.data?.is_device_service == 1 || res?.data?.is_device_service == true;
        const logo = res?.data?.logo;
        
        const customerId = res?.data?.id;
        if (logo) {
            // Case 1: Logo available from API
            this.finalLogoUrl = logo;
            
            
        } else {
            // Case 2: Logo empty → show default based on customer_id
            if (customerId == 84) {
                this.finalLogoUrl = 'assets/img/brand/vigologo.svg';
            } else {
                this.finalLogoUrl = 'assets/img/brand/Pathoconnect-Logo.png';
            }
        }
        console.log('finalLogoUrl', this.finalLogoUrl);

    },
    error: (err) => {
      console.error(err);
    }
  });
    // this.isDeviceService = localStorage.getItem('is_device_service') == 'true' || localStorage.getItem('is_device_service') == '1';

  }






  submit() {
    this.isBtnLoaded = true;
    // let eid=atob(this.id);
        // let did = eid.split(',');
        // https://q2vh927ipi.execute-api.us-east-1.amazonaws.com/addFeedbackPhlebo?unique_id=SDBKNTNhbmJvUGo3czV0WmNPNHk3Zz09

    this.ratingData={rating:this.starRating,remarks:this.ngremark}

    if (this.ratingData) {

        this.orderService.onSaveRating(this.ratingData,this.id).subscribe((res: any) => {
            if (res.success) {
                this.toastr.success(`${res.message}`);
                this.isBtnLoaded = false;
                this.starRating = 0;
                this.ngremark = '';
            } else {
                if (res.error) {
                    this.isBtnLoaded = false;
                    this.toastr.error(`${res.error}`);
                } else {
                this.isBtnLoaded = false;

                    this.toastr.error(`Feedback failed to submit. Please try again later.`);
                }
            }
        },
        (err: any) => {
            this.toastr.error(`${err}`);
        },
        () => {
            this.isBtnLoaded = false;
        })
    }
    else {
        this.isBtnLoaded = false;

    }
}

}
